import { render, staticRenderFns } from "./ResetPasswordDone.vue?vue&type=template&id=345aa50b"
import script from "./ResetPasswordDone.vue?vue&type=script&lang=js"
export * from "./ResetPasswordDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports